import IconClockRotateLeftSolid from '@/assets/icons/font_awesome/clock-rotate-left-solid.svg?react';
import { ICON__magnifying_glass } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_search, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export function SButtonShowSearchHistory() {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { page_search_show_history } = use_slice_ui(['page_search_show_history']);
  const { search_history_map } = use_slice_search(['search_history_map']);

  const onClick = () => {
    dispatch(LOCAL__ui_set_boolean({ value: !page_search_show_history, key: 'page_search_show_history' }));
  };

  if (search_history_map.size === 0) return <PLACEHOLDER_BUTTON__bar />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW)) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__tooltip
      tooltip_title={
        page_search_show_history
          ? `${t(i18n_page_search.sidebar.button.show_search_history.tooltip_hide)}`
          : `${t(i18n_page_search.sidebar.button.show_search_history.tooltip_show)}`
      }
      side="top"
    >
      <UI_PRIMITIVE__button_with_icon_animated
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        variant="no-border-on-component"
        size="icon"
        onClick={onClick}
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={page_search_show_history ? ICON__magnifying_glass : IconClockRotateLeftSolid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
